<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="FMH"><span class="ePub-BI">Contents</span></p>
<p class="sp1"> </p>
<p class="CFMH"><span class="ePub-I"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></span></p>
<p class="CFMH"><span class="ePub-I"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></span></p>
<p class="CFMH"><span class="ePub-I"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></span></p>
<p class="CFMH1"><span class="ePub-I"><span href="#/xhtml/epigraph#epig" title="Link target outside of Sample">Epigraph</span></span></p>
<p class="CFMH"><a href="#/xhtml/prologue#prol">Prologue</a></p>
<p class="CCT">  1. <a href="#/xhtml/chapter1#ch1">The Gilded Age: A Tale of Yesterday</a></p>
<p class="CCT">  2. <a href="#/xhtml/chapter2#ch2">The Cosmopolitan Standard of Virtue</a></p>
<p class="CCT">  3. <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">That Shudder of Fascination</span></p>
<p class="CCT">  4. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">A Certain Sensuous Charm</span></p>
<p class="CCT">  5. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">How to Read Gertrude Stein</span></p>
<p class="CCT">  6. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">In Defense of Bad Taste</span></p>
<p class="CCT">  7. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">What One Is Forced by Nature to Do</span></p>
<p class="CCT">  8. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">An Entirely New Kind of Negro</span></p>
<p class="CCT">  9. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Exotic Material</span></p>
<p class="CCT">10. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Cruel Sophistication</span></p>
<p class="CCT">11. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">A Quite Gay, but Empty, Bubble That Dazzles One in Bursting</span></p>
<p class="CCT">12. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Papa Woojums</span></p>
<p class="CCT">13. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Yale May Not Think So, but It’ll Be Just Jolly</span></p>
<p class="CCT"><span href="#/xhtml/epilogue#epil" title="Link target outside of Sample">Epilogue: The Attention That I Used to Get</span></p>
<p class="CBMH1"><span class="ePub-I"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Select Bibliography</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/illust_credits#illust" title="Link target outside of Sample">Illustration Credits</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/aboutauthor#about" title="Link target outside of Sample">A Note About the Author</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/Copyright#crt" title="Link target outside of Sample">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?395d9a80